module.exports = __webpack_public_path__ + "img/whitestars.995f9228.png";